import { Component, EventEmitter, Input, Output } from '@angular/core';
import {
    UntypedFormBuilder,
    FormsModule,
    ReactiveFormsModule
} from '@angular/forms';

import { untilDestroyed, UntilDestroy } from '@ngneat/until-destroy';
import { TranslateModule } from '@ngx-translate/core';
import { CurrencyConvertPipe } from '../../../../shared/pipes';
import { IconComponent } from '../../../../shared/components/icon/icon.component';
import { NgFor, NgIf } from '@angular/common';

@UntilDestroy()
@Component({
    selector: 'app-blocks-calculator',
    templateUrl: './blocks-calculator.component.html',
    styleUrls: ['./blocks-calculator.component.scss'],
    standalone: true,
    imports: [
        NgFor,
        FormsModule,
        ReactiveFormsModule,
        NgIf,
        IconComponent,
        CurrencyConvertPipe,
        TranslateModule
    ]
})
export class BlocksCalculatorComponent {
    @Input() height: number;
    @Input() width: number;
    @Input() type: string;
    @Input() taxedPrice: number;
    @Input() companyId: string;
    @Input() productId: string;
    @Input() currencyCode: string;

    @Output() quantity: EventEmitter<number> = new EventEmitter<number>();
    formsList = [
        this.fb.group({
            height: 0,
            width: 0
        })
    ];
    tPrice = 0;
    tCount = 0;
    oldAmount = 1;
    constructor(private fb: UntypedFormBuilder) {}

    ngOnInit(): void {}

    getArea() {
        let areaList = [];
        for (let i = 0; i < this.formsList.length; i++) {
            areaList.push(
                this.formsList[i].value.height * this.formsList[i].value.width
            );
        }
        return areaList;
    }

    addArea() {
        this.formsList.push(
            this.fb.group({
                height: 0,
                width: 0
            })
        );
    }

    removeArea() {
        this.formsList.pop();
        this.getAreaPrice();
    }

    getAreaPrice() {
        this.tPrice = 0;
        this.tCount = 0;
        const totalArea = this.getArea();
        let productArea = this.height * this.width;

        const checkbox = document.getElementById(
            'extra'
        ) as HTMLInputElement | null;

        if (this.type == 'cm') {
            productArea /= 100 * 100;
        }

        if (this.type == 'mm') {
            productArea /= 1000000;
        }

        if (this.type == 'in') {
            productArea /= 39.37 * 39.37;
        }

        let neededArea;
        for (let i = 0; i < totalArea.length; i++) {
            neededArea = Math.round(totalArea[i] / productArea);
            this.tPrice += this.taxedPrice * neededArea;
            this.tCount += neededArea;
        }

        if (checkbox?.checked) {
            neededArea = Math.round(neededArea * 0.05);
            this.tPrice += this.taxedPrice * neededArea;
            this.tCount += neededArea;
        }

        if (this.tCount) this.quantity.emit(this.tCount);
    }
}
